export const m = {
  header: {
    navbar: {
      HELLO: "您好",
      LOGOUT: "退出",
      TITLE: "欢迎使用Japan Night",
      new: {
        NEW: "New",
        PROJECT: "项目",
        TASK: "任务",
        USER: "用户",
        EMAIL: "Email"
      },
      NOTIFICATIONS: "通知",
      APP_TITLE: "Japan Night"
    }
  },
  aside: {
    APPNAME: "Japan Night",
    nav: {
      INDEX: "首页",
      SHOPS: "店铺管理",
      SHOP: "店铺",
      ROOM: '包间管理',
      TIME: '时间管理',
      ACTIVITYS_TUBE: "活动管理",
      ACTIVITYS: "活动",
      ACTIVITY_CATEGORY: "活动分类",
      ACTIVITYS_SAT: "活动统计",
      LIVES: "直播管理",
      LIVE: "直播设置",
      ORDER_TUBE: "订单管理",
      ORDER: "门票订单管理",
      ORDER_SAT: "订单统计",
      USERGOODS_MANAGEMENT: '用户商品管理',
      MEMBERS: "会员管理",
      MEMBER: "会员",
      MEMBEROFFCIAL: "客服设置",
      MEMBERS_BANNED: "会员黑名单记录",
      MEMBER_RECHARGE_MANAGE: "优享会员管理",
      MEMBER_RECHARGE: "优享会员",
      COUPON: "优惠劵",
      COUPON_MANAGE: "优惠券列表",
      COUPON_TABLE: "优惠券发放列表",
      COUPON_REGISTER: "推荐注册优惠券设置",
      COUPON_USEAGE_RECORD: '优惠券使用记录',
      ARTICLES: "文本管理",
      ARTICLE: "文本列表",
      COMMENDS: "评论管理",
      COMMEN: "评论列表",
      RECHARGES: "资金管理",
      RECHARG: "充值记录",
      GAME: "游戏设置",
      PRIZE_SET: "中奖设置",
      PRIZE_DETAILS: "游戏消费明细",
      BACKSTAGE: "后台功能",
      ROLE: "角色管理",
      SHOPROLE: "店铺管理员设置",
      ACCOUNT: "平台管理员设置",
      SYSLOGS: "操作日志",
      LANGUAGES: "多语言设置",
      MUSICS: "音乐类型",
      REGIONS: "区域设置",
      RECEPTION: "前台功能",
      BANNER: "广告管理",
      SPLASHE: "闪屏管理",
      VERSIONS: "版本管理",
      PUSHES: "推送管理",
      CONFIG: "前台配置",
      CONFIG_FEATURE: "功能配置",
      CONFIG_APP: "应用配置",
      INVITATE_CODES: "邀请码管理",
      INVITATE_CODE: "邀请码",
      DIALOG_MANAGEMENT: "弹窗管理",
      POPUP: "弹窗",
      THEMES: "主题管理",
      THEME: "主题",
      MENBER_CHARGE: "会员充值列表",
      CHARGE_OFF: "核销权限",
      USER_MANAGE: "用户管理",
      CARD_GROUP_STYLE: "卡片组样式管理",
      CARD_GROUP: "卡片组管理",
      CARD: "卡片管理",
      PREMISSION_MANAGE: "权限管理",
      MODEL: "模板管理",
      PAGE: "页面管理",
      CONFIG_MANAGE: "配置管理",
      LABEL: "标签管理",
      LOTTERY: "抽奖权限",
      TICKET: "用户门票管理",
      USERGOODS_MANAGEMENT: '用户商品管理',
      GIFT: "礼物设置",
      FULL_AMOUN_COUPON: "满额优惠券设置",
      COIN_MANAGE: "充值内购管理",
      COIN_RECHARGE: "充值设置",
      COIN_RECHARGE_RECORDE: "充值记录",
      GIFT_REWARD: "直播打赏统计",
      GIFT_CATEGORY: "礼物分类",
      LIVE_CATEGORY: "直播分类",
      SHOP_CATEGORY: "店铺分类",
      SHOP_APPLY: "商户申请管理",
      RETURN_POINT: "返点记录",
      PRESENT_SET: "礼品设置",
      RECHANGE_PRESENT: "礼品兑换记录",
      RECHANGE_MANAGEMENT: "礼品管理",
      POINTS: "点数管理"
    }
  },
  content: {
    common: {
      ACTION: "操作",
      EDIT: "编辑",
      SAVE: "保存",
      COPY: "复制",
      DELETE: "删除",
      IS_DELETE: "您确认删除吗？",
      CREATE: "创建",
      NUMBER: "编号",
      STATUS: "状态",
      SORT: "排序",
      SEARCH: "搜索",
      RESET: "重置",
      ACTION_ALL: "批量操作",
      DELETE_ALL: "批量删除",
      APPLY: "应用",
      DETAIL: "详情",
      CLOSE: "关闭",
      OPEN: "开启",
      LINK: "链接",
      SURE: "确定",
      CANCEL: "取消",
      REFUSE: "拒绝",
      ADOPT: "通过",
      TEL: "电话",
      PLEASE_INPUT: '请输入',
      LINK_ZDY: "自定义",
      LINK_REMINDER: "请选择链接类型",
      LINK_REMINDER_UP: "请输入链接",
      SELECTPICTURE: "选择图片",
      PLEASE_SELECTPICTURE: "请选择图片",
      RIGHT_SELECTPICTURE: "点击右侧按钮上传图片",
      PLATFORM: "平台",
      SELECT: "请选择",
      WRITE: "请输入",
      PHOTO: "图片",
      PLEASE_AREA_CODE: "请选择区号",
      PLEASE_WRITE_TEL: "请输入电话",
      PHOTO_RESTRICT: "图片限制",
      PHOTO_UPLOADING: "图片上传",
      VIDEO_UPLOADING: "视频上传",
      CLICK_UPLOADING: "点击上传",
      ZIP_UPLOADING: "只能上传ZIP文件",
      OPEN_TIME: "开始时间",
      OFF_TIME: "结束时间",
      OPEN_OFF_TIME: '开始&结束时间',
      PLEASE_SORT: "请输入排序",
      SORT_INT: "请输入正整数的排序",
      USER_NAME: "用户名",
      USER_TEL: "用户电话",
      EGION_ALL: "全部区域",
      PASSWORD: "密码",
      PASSWORD_AT: "新密码",
      TIPS_PASSWOR: "无需修改则不填",
      VERIFY_PASSWORD: "确认密码",
      PLEASE_PASSWORD: "请输入正确的密码",
      PLEASE_VERIFY_PASSWORD: "请再次输入密码",
      NOT_VERIFY_PASSWORD: "两次输入的密码不一样",
      PHOTO_REQIREMENT: "上传图片不符合要求",
      CONFIG_DELERTE: "确定要删除吗",
      SUCCESSFUL_OPERASTION: "更新成功",
      SUCCESSFUL_FAILED: "更新失败",
      PLEASE_OPEN_TIME: "请选择开始时间",
      PLEASE_OFF_TIME: "请选择结束时间",
      STARTTIME_LESS_ENDTIEM: "开始时间要小于结束时间",
      LATITUDE_AND_LONGITUDE: "未获取到经纬度",
      EDITORS: "编辑中",
      CREATION: "创建中",
      PRICE_SEVEN: "价格不能超过7位数",
      PRICE_INTEGER: "请输入价格且只能为大于等于0的正整数",
      PRICE_CONFIG_DELERTE: "请选择要删除的对象",
      REMINDER: "温馨提示",
      TOTAL_PAGE: "共",
      JUMP_TOTAL: "页",
      JUMP_PAGE: "跳转至",
      YES: "是",
      NO: "否",
      SIZE: "大小",
      addimage: "添加图片",
      NODATA: "暂无数据",
      LOADING: "正在加载····",
      LIST_NULL: "暂无数据",
      ADD: "添加",
      IMAGE_NLL: "请上传图片",
      PASSWORD_LESS: "密码不能少于6个字符",
      READ: "查看",
      PREMISSION: "权限",
      COUNT: "数量",
      IP: "IP地址",
      NULL: "无",
      IOS: "iOS",
      ANDROID: "Android",
      ALL_PLATEFORM: "全平台",
      UPLOAD_IMAGE_NULL: "上传图片尺寸不符合要求",
      UPLOAD_IMAGE_SUPPORT: "只支持上传图片格式",
      UPLOAD_IMAGE_NOT: "上传图片大小不能超过2MB!",
      SEND_SUCCESS: "发送成功",
      LINK_UPLOAD: "请输入图片链接",
      DELETE_SUCCESS: "删除成功",
      DELETE_FAIL: "删除失败",
      ADMIN: "管理后台",
      CHECK: "核销端",
      H5: "网页端",
      REGION_VALID: "店铺区域需要详细到市级",
      CREATE_SUB_CATEGORY: "创建下级分类",
      SUB_NUM: "子分类数",
      CREATE_SUCCESS: "创建成功",
      CREATE_FAILD: "创建失败",
      JAPAN_LANGUAGE: "日本語",
      CHINESE_LANGUAGE: "简体中文",
      SURE_PHYSICAL: "物理删除文件(删除文件将造成引用图片失效，请谨慎决定)",
      UPLOAD_ORIGIN: "本地上传",
      URL_UOPLOAD: "URL上传",
      PICLIST: "图库选择",
      ZHI: "至",
      PLEASE_CATEGORY: "请选择分类",
      APPLY_SUCCESS: "审核通过",
      APPLY_FALIED: "审核拒绝",
      IS_APPLY_SUCCESS: "是否确认审核通过？",
      IS_APPLY_REFUSED: "是否拒绝审核？",
      PLEASE_EMAIL: "请输入正确的邮箱格式",
      TIWCE_PASSWORD: "两次密码不一致",
      STOCK_INT: "库存只能是正整数",
      EXPORT_PRESENT_RETURN: "导出礼品兑换记录",
      PRESENT_RETURN_MANY: "导出记录不能超过1万条",
      CHANGE_SHOP: "确认切换店铺吗？",
      TIP: "提示",
      MAPS: '地图',
      CANCEL_CHANGE: "取消切换",
      MAPS_LOADING: "地图加载中",
      MAPS_FAIL: "地图加载失败",
      NET_ERR: "网络错误",
      UPLOAD_SUCCESS: "上传成功",
      CLICK_FOR_DETAIL: '点击查看详情',
      RECORD: "条记录",
      QUICK_TRANSLATION: '一键翻译',
      EXPORT_LOADING: '导出任务进行中，请在下拉菜单中查询导出进度',
      DOWN_LOAD: '下载',
      INPUT_INT: '请输入一个整数',
      INPUT_NO_MINUS: '请输入一个大于等于0的整数',
      INPUT_INCOMPLETE: '未填写完整'
    },
    index: {
      ALLUSER: "总用户数",
      ACTIVITYUSERS: "活跃用户数",
      NEWUSERS: "新增用户数",
      LAUNCHES: "启动次数",
      USER_ONLINE: "在线人数",
      TODAY: "今日",
      YESTERDAY: "昨日",
      TIME_FRAME: '时间范围',
      EXPORT: '导出',
      DASHBOARD_EXPORT: '导出',
    },
    shop: {
      SHOPLIST: "店铺列表",
      SHOP_CREATE: "创建店铺",
      SHOP_MODIFY: "修改店铺",
      SHOPLOGO: "店铺Logo",
      TITCKELOGO: "小票Logo",
      SHOPNAME: "店铺名称",
      SHOP_REGIONS: "店铺区域",
      SHOP_SITE: "店铺地址",
      SHOP_TEL: "店铺电话",
      SHOP_ACTIVITY_COUNtT: "活动数",
      SHOP_LIKE_COUNtT: "点赞数",
      RECOMMEND: "推荐",
      SHOP_DETAIL: "店铺信息",
      PLEASE_ENTER_SHOPNAME: "请输入店铺名称",
      SHOP_KEYWORD: "店铺检索关键字",
      PLEASE_SHOP_KEYWORD: "请输入检索关键字",
      SHOP_ADMIN: "店铺所有者",
      PLEASE_SHOP_ADMIN: "请选择店铺所有者",
      PLEASE_SHOP_ADMINISTRATORDS: "请选择店铺管理员",
      SHOP_TIME: "营业时间",
      STATISTICS_TIME: "统计时间",
      SHOP_DESC: "店铺描述",
      SHOP_OPEN: "开业",
      SHOP_OFF: "休业",
      PLEASE_SHOP_DESC: "请输入店铺描述",
      PLEASE_SHOP_SITE: "请输入地址",
      SHOP_URL: "店铺URL",
      PLEASE_SHOP_REGIONS: "请选择区域",
      PLEASE_SHOP_OPEN_TIME: "请选择营业开始时间",
      PLEASE_SHOP_OFF_TIME: "请选择营业结束时间",
      PLEASE_TATOL_OPEN_TIME: "请选择统计开始时间",
      PLEASE_TATOL_OFF_TIME: "请选择统计结束时间",
      PLEASE_WRITE_LINK: "请输入正确的网址",
      PLEASE_SHOP_STATUS: "请选择状态",
      PLEASE_SHOP_TEL: "请输入管理员电话",
      SHOP_TEL_NUMbER: "电话只能输入数字",
      SHOP_LIKE_COUNtT_NUMBER: "虚拟点赞数只能输入数字",
      PLEASE_SHOP_DESC_LENGTH: "店铺地址超过最大输入长度",
      SHOP_ACTIVITY: "店舗活动",
      PLEASE_SHOP: "请选择店铺",
      PHOTO_PESOLVING: "建议分辨率为 320*320 以上",
      ACTIVITYS_CAN: "是否允许活动购买",
      PRODUCT_CAN: "是否允许商品购买",
      BADGE_CAN: "是否开启徽章",
      SHOP_IS_DISPLAY: "是否做店铺展示",
      BADGE_NAME: "徽章名称",
      BADGE_LOGO: "徽章Logo",
      SHOPS_PESOLVING: "建议分辨率为 200*100 以下",
      SHOP_CODE: "店铺二维码",
      DOWNLOAD_CODE: "下载二维码",
      ALL_SHOPS_APPLY: "全店铺适用",
      SHOP_PICTURES: "店铺图片",
      SHOP_BASIC_DETAIL: "店铺基本信息",
      SHOP_TYPE: "店铺类型",
      SHOP_STATUS_SET: "店铺状态设置",
      SHOP_THREE: "第三方门店",
      BADGE_DESC: "徽章优惠描述",
      PLEASE_BADGE_DEAC: "请输入徽章描述",
      LINK_ADD_IMAGE: "根据连接添加",
      ADVISE_SIZE_IS: "建议尺寸为",
      SIZE_NOT: "大小不超过2MB",
      MORE_THAN: "最多可上传",
      CHANGE_PICTURE_ORDER: "可拖拽更改图片顺序",
      ADD_COUPON: "添加优惠券",
      NO_INFER: "无下级区域",
      IS_RECOMMEND: "是否推荐",
      PLEASE_BADGE_NAME: "请输入徽章名称",
      IS_OPEN_WOMANMENBER: "是否开启BEAUTY会员",
      WOMANMENBER_DESC: "BEAUTY会员描述",
      WOMANMENBER_LOGO: "BEAUTY会员Logo",
      PLEASE_UPLOAD_LOGO: "请上传店铺Logo",
      AA_SHOP_CATEGORY: "创建店铺分类",
      PLEASE_SHOP_CLASS: "请选择店铺分类",
      SHOP_MANAGEMENT_SET: "店铺经营设置",
      PLATE_MYSELEF: "平台自营",
      OTHER_MANAGE: "第三方经营",
      REVIEWS: "评论数",
      NIGHT_CLUB: "夜店",
      BAR: "酒吧",
      CLUB: '俱乐部/牛郎店',
      WAITER: '卡司',
      WAITER_EDIT: '人员編集',
      WAITER_CREATE: '创建卡司',
      WAITER_DETAIL_BASIC: '基本信息',
      WAITER_DETAIL_RESUME: '简历设置',
      WAITER_DETAIL_SCHEDULE: '日程设置',
      WAITER_AVATAR: '头像',
      WAITER_BODY_DATA: '形体数据',
      WAITER_BODY_HEIGHT: '身高(T)',
      WAITER_BODY_BUST: '胸围(B)',
      WAITER_BODY_WAISTLINE: '腰围(W)',
      WAITER_BODY_HIPLINE: '臀围(H)',
      WAITER_BLOOD_TYPE: '血型',
      WAITER_SIGN_TYPE: '星座',
      WAITER_SIGN_TYPE_ARIES: '白羊座',
      WAITER_SIGN_TYPE_TAURUS: '金牛座',
      WAITER_SIGN_TYPE_GEMINI: '双子座',
      WAITER_SIGN_TYPE_CANCER: '巨蟹座',
      WAITER_SIGN_TYPE_LEO: '狮子座',
      WAITER_SIGN_TYPE_VIRGO: '处女座',
      WAITER_SIGN_TYPE_LIBRA: '天秤座',
      WAITER_SIGN_TYPE_SCORPIO: '天蝎座',
      WAITER_SIGN_TYPE_SAGITTARIUS: '射手座',
      WAITER_SIGN_TYPE_CAPRICORN: '摩羯座',
      WAITER_SIGN_TYPE_AQUARIUS: '水瓶座',
      WAITER_SIGN_TYPE_PISCES: '双鱼座',
      WAITER_INTRODUCE: '简介',
      PLEASE_UPLOAD_AVATAR: '请上传头像',
      WAITER_RESUME_INFO: '简历信息',
      WAITER_RESUME_QUESTION: '问题',
      WAITER_RESUME_ANSWER: '回答',
      WAITER_RESUME_KEY_ERR: '请输入问题',
      WAITER_RESUME_VALUE_ERR: '请输入答案',
      WAITER_CALENDAR_WORK_STATUS: '出勤状态',
      WAITER_CALENDAR_WORK_STATUS_DEFAULT: '未设置',
      WAITER_CALENDAR_WORK_STATUS_WORK: '出勤',
      WAITER_CALENDAR_WORK_STATUS_REST: '休息',
      WAITER_CALENDAR_MONDAY: '星期一',
      WAITER_CALENDAR_TUESDAY: '星期二',
      WAITER_CALENDAR_WEDNESDAY: '星期三',
      WAITER_CALENDAR_THURSDAY: '星期四',
      WAITER_CALENDAR_FRIDAY: '星期五',
      WAITER_CALENDAR_SATURDAY: '星期六',
      WAITER_CALENDAR_SUNDAY: '星期日',
      WAITER_CALENDAR_SETTING_TYPE: '设置类型',
      WAITER_CALENDAR_SETTING_TYPE_WEEK: '按星期',
      WAITER_CALENDAR_SETTING_TYPE_DAY: '按连续天数',
      WAITER_CALENDAR_SETTING_WEEK: '适用星期',
      WAITER_CALENDAR_SETTING_TIP_WORK: '将本月未设置日期的出勤状态设置为出勤',
      WAITER_CALENDAR_SETTING_TIP_REST: '将本月未设置日期的出勤状态设置为休息',
      WAITER_CALENDAR_SETTING_TYPE_ERR: '请选择设置类型',
      WAITER_CALENDAR_SETTING_WEEK_ERR: '请选择适用星期',
      WAITER_CALENDAR_SETTING_DATE_ERR: '请选择时间范围',
      WAITER_CALENDAR_WORK_STATUS_ERR: '请选择出勤状态',
      CONSUME_INFO: "消费说明",
      PREFERENTIAL_INFO: "优惠说明",
      CATEGORY_SHOP_NUM: "店铺数",
      NEW_SHOP_NUM: "总店铺数",
      BUSINESS_SHOP: "营业中",
      MOUNTH_NEW_SHOP_NUM: "本月新增",
      MOUNTH_CREATED_SHOP_NUM: "本月更新",
      SHOPAPPLY_EDIT: "编辑商户入驻申请",
      ALL_SHOP_USED: "适用于全部店铺",
      SHOP_CATEGOEY_VALID: "店铺分类最多设置三个",
      POINT_CODE: "印花二维码",
      SHOP_SIGNIN_GIVE_POINTS: "店铺签到送点数",
      CHOOSE_ALLOW_ACTIVITY_BUY: '请选择是否允许活动购买',
      CHOOSE_ALLOW_BUY: '请选择是否允许商品购买',
      NAME_TIPS: "店铺名称不能包含EMOJI表情",
      POINT_USE_SETTING: '免费/付费点数使用设置',
      FREE_POINT: '免费点数',
      PAID_POINT: '付费点数',
      MAX_DEDUCTION: '使用上限',
      POINT_USE_TIPS: '-1代表可以全额抵扣',
      GOODS_REBATE_AMOUNT: '购买返现设置(请输入返现百分比)',
      PLEASE_CHECK: '请至少勾选一项使用设置',
    },
    room: {
      CREATE_COMPARTMENT: '创建包间',
      NAME: '包间名称',
      PLEASE_NAME: '请输入包间名称',
      USERS: '人数',
      PLEASE_MIN_USERS: '请输入最小人数',
      PLEASE_MAX_USERS: '请输入最大人数',
      PRICE: '基础价格',
      PLEASE_PRICE: '请输入基础价格',
      EXTRA_PRICE: '额外价格',
      REFUND_FEE: '退款手续费',
      PLEASE_FEE: '请输入手续费百分比',
      EACH_PERSON: '每人',
      UN_APPOINTMENT: '不可预订',
      APPOINTMENT: '可预订',
      APPOINTMENTED: '已预订',
      SETTINGS: '批量设置',
      CREATE_TITLE: '可预订时间段设置',
      OPEN_OFF_TIME: '开始结束时间',
      TIME_SETTING: '时间段设置',
      PLEASE_TIME_SETTING: '请选择时间段',
      TIME_SETTING_ERROR: '时间段选择不允许重复',
    },
    activitys: {
      ACTIVITY_LIST: "活动列表",
      ACTIVITY_ONE_PHOTO: "活动首图",
      ACTIVITY_NAME: "活动名称",
      ACTIVITY_NAME_CLICK: "活动名称（点击数 / 点赞数）",
      ACTIVITY_CREATE: "创建活动",
      ACTIVITY_SHOP: "活动所属店铺",
      PLEASE_ACTIVITY_SHOP: "请选择所属门店",
      ACTIVITY_REGIONS: "活动区域/地址",
      ACTIVITY_PRAISE: "点赞数",
      ACTIVITY_MUSIC: "音乐类型",
      ACTIVITY_TIME: "活动时间",
      ACTIVITY_DETAIL: "活动信息",
      ACTIVITY_DESC: "活动描述",
      ACTIVITY_TYPE: "活动类型",
      ACTIVITY_TEL: "活动电话",
      ACTIVITY_SITE: "活动地址",
      PLEASE_ACTIVITY_NAME: "请输入活动名称",
      PLEASE_ACTIVITY_DESC: "请输入活动描述",
      ACTIVITY_PRICE_MALE: "男性价格",
      ACTIVITY_PRICE_FAMALE: "女性价格",
      PLEASE_ACTIVITY_PRICE: "请输入活动价格",
      ACTIVITY_VIRTUAL_PRAISE: "活动虚拟点赞数",
      PLEASE_VIRTUAL_PRAISE: "请输入虚拟点赞数",
      ACTIVITY_AGAIN_PRICE: "再入场费用",
      PLEASE_AGAIN_PRICE: "请输入再入场费用",
      WHETHER_REFUND: "是否允许退款",
      PLEASE_WHETHER_REFUND: "至少填写一个退款有效期",
      RETURNABLE: "可退",
      NO_RETURNABLE: "不可退",
      REFUND_HALF: "退一半",
      REFUND_NO: "不退",
      REFUND_ALL: "全退",
      ACTIVITY_PUTAWAY: "上架开关",
      ACTIVITY_TOP_PUTAWAY: "上架",
      ACTIVITY_up_PUTAWAY: "下架",
      PUTAWAY_DAY: "日前",
      DISCOUNTS: "优惠信息",
      DISCOUNTS_CONDITION: "优惠条件",
      DISCOUNTS_LIST: "优惠列表",
      DISCOUNTS_DESC: "优惠描述",
      PLEASE_DISCOUNTS_DESC: "请输入优惠描述",
      DISCOUNTS_PRICE: "优惠金额",
      PLEASE_DISCOUNTS_PRICE: "请输入优惠金额",
      DISCOUNTS_SHARE: "能否与其他优惠并用",
      PLEASE_DISCOUNTS_SHARE: "请选择是否可以并用",
      DISCOUNTS_GIVE: "赠送设置",
      PLEASE_DISCOUNTS_GIVE: "请选择赠送设置",
      GIVE_DESC: "赠送描述",
      GIVE_DRINK: "赠饮描述",
      DISCOUNTS_UNLIMITED: "无限畅饮",
      DISCOUNTS_CUP: "杯",
      PHOTO_FIVE: "图片最多上传5张",
      PLEASE_ACTIVITY_NAME_DESC: "请输入活动名称与描述",
      PLEASE_ACTIVITY_NAME_LENGTH: "活动名称超过最大范围",
      ACTIVITY_AGAIN_PRICE_SEVEN: "再入场费用不能超过7位数",
      ACTIVITY_AGAIN_PRICE_INTEGER: "请输入再入场费用且只能是正整数",
      ACTIVITY_TICKET_COUNT: "请输入门票生成张数且只能是正整数",
      ACTIVITY_TICKET_THANONE: "门票生成张数必须大于等于1",
      WHETHER_REFUND_TIME: "请输入退款有效期",
      PLEASE_ACTIVITY_PUTAWAY: "请选择上下架",
      ACTIVITY_NOT_SHOP: "活动无店铺",
      ACTIVITY_MUSIOCS_TYPE: "请选择音乐类型",
      PLEASE_ACTIVITY_MUSIOCS_TYPE: "最多可选3种音乐类型",
      ACTIVITY_COPY: "确定要复制此活动吗？",
      PLEASE_ACTIVITY_TYPE: "请选择活动类型",
      PLEASE_WHETHER_NBMER: "可退天数只能是数字",
      WHETHER_REFUND_PLEASE: "请选择是否允许退款",
      DISCOUNTS_GIVEA_DRINK: "赠饮",
      DISCOUNTS_GIVEA_MERGE: "合并",
      DISCOUNTS_GIVEA_NO_MERGE: "不合并",
      DISCOUNTS_TYPE: "优惠类型",
      DISCOUNTS_OTHER_TYPE: "其他",
      DISCOUNTS_GIVEA_DRINK_SET: "赠饮设置",
      DISCOUNTS_GIVEA_GIVE_SETONE: "赠送设置1",
      DISCOUNTS_GIVEA_GIVE_SETTOW: "赠送设置2",
      DISCOUNTS_CUP_NUMBER: "赠饮杯数",
      GIVEA_DRINK_NUMBER: "赠饮杯数只能输入数字",
      PLEASE_CUP_NUMBMER: "请填写赠饮杯数",
      PLEASE_DISCOUNTS_DESC: "请输入优惠描述",
      PLEASE_DISCOUNTS_DESC_LENGHT: "优惠描述超过最大限制长度",
      PLEASE_DISCOUNTS_GENDER: "请选择性别",
      PLEASE_DISCOUNTS_TYPE: "请选择优惠类型",
      PLEASE_DISCOUNTS_TYPE_NAME: "请填写其他类型名称",
      PLEASE_PRICE: "请输入价格",
      PLEASE_DISCOUNTS_ANDUSE: "请选择是否并用",
      ACTIVITY_GUEST: "是否有特邀嘉宾",
      ACTIVITY_PAY: "是否允许购买",
      ACTIVITY_RANKING: "排名",
      ACTIVITY_TICKET: "活动门票",
      ACTIVITY_TICKET_LIST: "门票列表",
      ACTIVITY_GENERATE_TICKET: "生成门票",
      ACTIVITY_TICKET_NAME: "收票人昵称",
      ACTIVITY_USAGE_QUANTITY: "已使用数/未使用数",
      ACTIVITY_GIT_AMOUNT: "已赠送/未赠送",
      ACTIVITY_OPERATION: "操作",
      ACTIVITY_ID: "ID",
      ACTIVITY_GENERATE_NUM: "生成数量",
      ACTIVITY_TICKET_COLLECTOR: "收票人",
      ACTIVITY_CONFIRM: "确认生成",
      ACTIVITY_PRICE: "活动价格",
      ACTIVITY_PLEASE_INPUT: "请输入",
      ACTIVITY_DISCOUNTS: "优惠",
      ACTIVITY_DETERMINE: "确定",
      ACTIVITY_INPUT_NUMBER: "请输入生成数量",
      ACTIVITY_INPUT_NUMBER_TEST: "生成数量必须是大于0的正整数",
      ACTIVITY_ADD_TICKETS: "请添加收票人",
      ACTIVITY_DETERMIN_TICKETS: "确定生成门票",
      ACTIVITY_NO_DISCOUNTS: "无优惠信息",
      ACTIVITY_SHEET: "门票生成张数",
      OPEN_SPECIAL: "是否开启特价",
      SPECIAL_OFFER_MAN: "男性特价",
      SPECIAL_OFFER_WOMAN: "女性特价",
      SPECIAL_LINE_PURCHASE: "活动购买设置",
      ALLOW_ACTIVITY_PURCHASE: "允许活动购买",
      NOALLOW_ACTIVITY_PURCHASE: "禁止活动购买",
      SPECIAL_END: "特价结束时间",
      SPECIAL_TITLE: "特价标题",
      SPECIAL_DESC: "特价描述",
      PLEASE_SPECIAL_TITLE: "请输入特价标题",
      PLEASE_SPECIAL_DESC: "请输入特价描述",
      PLEASE_TIME_END: "特价结束时间要大于当前时间",
      PLEASE_SPECIAL_TIME_END: "请选择特价结束时间",
      ACTIVITY_INVENTORY: "活动库存",
      ACTIVITY_STATUS_SET: "活动状态设置",
      ACTIVITY_SUCCESS: "复制成功",
      ISDISCOUNT: "能否与其他优惠并用",
      ADD_ACTIVITY_CATEGORY: "创建活动分类",
      CATEGORY_NAME: "分类名称",
      PLEASE_CATEGORY_NAME: "请输入分类名称",
      LOWER_CATEGORY_LIST: "下级分类列表",
      CHECK_ACTIVITY_ORDER: "活动订单",
      ADD_CHILDREN_CATEGORY: "添加下级分类",
      CREATE_ORDER: "生成订单",
      CURRENT_ORDER: "当前活动订单",
      IS_CANCEL_ORDER: "是否自动取消订单",
      ACTIVITY_CLASS: "活动所属分类",
      PLEASE_ACTIVITY_CLASS: "请选择活动所属分类",
      IS_BUY_TIME: "是否开启购买时间限制",
      IS_GIVEN: "是否允许转赠",
      IS_QUOTA: "是否开启限购",
      IS_BUY_OPEN_TIME: "活动购买开始时间",
      IS_BUY_OFF_TIME: "活动购买结束时间",
      CHOOSE_BUY_OPEN_TIME: '请选择活动购买开始时间',
      CHOOSE_BUY_OFF_TIME: '请选择活动购买结束时间',
      QUOTA_AMOUNT: "门票限购张数",
      PLEASE_TEST_QUOTA_AMOUNT: "门票限购张数必须是大于等于1的正整数",
      PLEASE_QUOTA_AMOUNT: "请输入门票限购张数",
      PLEASE_PURCHASE_TIME: "活动购买结束时间要大于开始时间",
      IS_LIMITED_ENTRY: "是否严格限制入场时间",
      LIMITED_ENTRY_AT: "活动允许提前入场时间",
      IS_VIP_PRICE: "是否开启优享会员价格",
      VIP_PRICE_END_AT: "优享会员活动结束时间",
      VIP_PRICE_TITLE: "优享会员活动标题",
      VIP_PRICE_DESC: "优享会员活动描述",
      VIP_PRICE_FEMALE: "优享会员价格女",
      VIP_PRICE_MALE: "优享会员价格男",
      SPECIAL_GUEST: "特邀嘉宾",
      ACTIVITY_COUNTRY: "全区域展示",
      SPECIAL_ACTIVITY: "特价活动",
      VIP_DESC: "优享会员描述",
      PLEASE_VIP_TITLE: "请输入优享会员价格标题",
      PLEASE_VIP_DESC: "请输入优享会员价格描述",
      ACTIVITY_SESSION: "活动场次",
      ACTIVITY_GROUPS: "活动分组",
      ACTIVITY_GROUPS_NAME: "活动分组名称",
      IS_OPEN_ACTIVITY_SESSION: "是否开启活动场次",
      ACTIVITY_SESSION_NAME: "活动场次名称",
      ACTIVITY_SESSION_DESC: "活动场次说明",
      OPEN_VIP: "优享会员专属价格开关",
      PLEASE_SELECT_DATE: "请选择日期",
      MALE_STOCK: "男性库存（不限制 -65535）",
      FEMALE_STOCK: "女性库存（不限制 -65535）",
      SESSION_STOCK: "场次库存（不限制 -65535）",
      IS_RNTER_PIE: "是否允许再入场",
      PURCHASE_SET: "购买相关设置",
      TOCKET_SET: "门票使用相关设置",
      OTHER_SET: "其他设置",
      STOCK: "库存",
      ACTIVITY_EXPLAIN: "年龄限制说明",
      PLEASE_EXPLAIN: "请输入年龄限制说明",
      PLEASE_SELECT_USERS: "请选择收票人",
      REFUND_VALID_NUM: "退款有效期只能输入数字",
      ACTIVITY_OPEN_TIME: "活动开始时间",
      ACTIVITY_OFF_TIME: "活动结束时间",
      ACTIVITY_CATAGORY_NUM: "活动数",
      ONLINE_PURCHASE_POINT: "线上购买返点设置（请输入支付金额的返点百分比）",
      PLEASE_ONLINE_PURCHASE_POINT: "请输入支付金额返点百分比",
      OFFLINE_PURCHASE_POINT: "印花设置",
      RETURN_POINT: "返点数",
      VALID_ONLINE_PURCHASE_POINT: "线上返点数只能输入大于0的正整数",
      RETURN_POINT_TIME: "返点时间",
      PRINT_NUM: "印花数",
      VALID_PRINT_NUM: "印花数只能是大于0的正整数",
      EXCHANGE_NUM: "兑换数量",
      EXCHANGE_TIME: "兑换时间",
      NOT_DELETE_ACTIVITY: "不能删除有订单的活动",
      ALL_CLOSE: "全部关闭",
      ALL_OPEN: "全部开放",
      PART_OPEN: "部分开放",
      ADD_ARTIST: "添加认证会员",
      ARTIST: "认证会员",
      PLEASE_ARTIST: "请输入认证会员昵称或电话",
      ARTIST_REFERRAL: "认证会员推荐购买返点设置",
      RETURN_MONEY_TITLE: '推荐购买返佣设置',
      PLEASE_ONLINE_PURCHASE_POINT: '%',
      PLEASE_RETURN_MONEY: '¥',
      OFFLINE_PURCHASE_POINT: '印花设置',
      RETURN_POINT: '返点数',
      RETURN_MONEY: '返佣金额',
      VALID_ONLINE_PURCHASE_POINT: '线上返点数只能输入大于0的正整数',
      RETURN_POINT_TOTAL: '总返点数',
      RETURN_POINT_PAID_AMOUNT: '总支付金额',
      RETURN_POINT_TIME: '返点时间',
      PRINT_NUM: '印花数',
      VALID_PRINT_NUM: '印花数只能是大于0的正整数',
      EXCHANGE_NUM: '兑换数量',
      EXCHANGE_TIME: '兑换时间',
      NOT_DELETE_ACTIVITY: '不能删除有订单的活动',
      ALL_CLOSE: '全部关闭',
      ALL_OPEN: '全部开放',
      PART_OPEN: '部分开放',
      ADD_ARTIST: '添加认证会员',
      ARTIST: '认证会员',
      PLEASE_ARTIST: '请输入认证会员昵称或电话',
      ARTIST_REFERRAL: '认证会员推荐购买返点设置',
      VALID_OFFLINE_PURCHASE_POINT: '印花数只能输入大于等于0的整数',
      IS_COMBINE: "合并显示",
      GROUP_COPY: "确定要复制此分组吗？",
      OPEN_LAST: "开启LAST",
      OPEN_PRICE_SET: "价格相关设置",
      COEXIST_WITH_ORIGINAL_ACTIVITY_PIICE: "与活动原价并存",
      SET_UP: "设置",
      SPECIAL_SETTINGS: "特价设置",
      PURCHASE_TIME_SETTING: "购买时间设置",
      PAID_MEMBER_PICE_SETTING: "付费会员价格设置",
      PURCHASE_RESTRICTION_SETTINGS: "限购设置",
      ACTIVITYS_NOTE: '注意事项',
      OPEN_TICKET_INDEX: '整理券',
      TICKET_INDEX_MUST_GREATER_0: '整理券数量必须大于0',
      ORDER_REMARKS: '订单备注',
      ORDER_REMARKS_NAME: '订单备注名称',
      PLEASE_ORDER_REMARKS_NAME: '请输入订单备注名称',
      TIME_TIPS: '注意：上下架时间 <= 开始结束时间',
      TIPS_REBATE: '返现在购买后立即记录，但只能在活动结束后提现（系统每小时自动检查一次，因此更新可能会有延迟）',
      TIPS_STOCK1: '开启自动取消后未付款订单10分钟自动取消',
      TIPS_STOCK2: '编辑库存建议下架活动10分钟后编辑',
      TIPS_STOCK3: '更改活动内容时，请不要更改库存数量',
      TIPS_COPY: '※复制内容需保存后生效',
      HAND_FEE: '手续费（円）',
      HAND_FEE_ERROR_MSG: '手续费只能输入大于或等于0的整数',
      SESSION_INFO: '场次信息',
      DISPLAY_GROUP: '分组',
      DISPLAY_CALENDAR: '日历',
      SIRCLE_SET: '循环设置',
      SIRCLE_TIPS: '循环创建的场次如需修改，请在列表处按日期筛选后逐个修改，请注意创建时间段等相关参数',
      SIRCLE_TIMES: '循环时间范围',
      DAILY: '每日',
      WEEKLY: '每周',
      MONTHLY: '每月',
      MONDAY: '周一',
      TUESDAY: '周二',
      WEDNESDAY: '周三',
      THURSDAY: '周四',
      FRIDAY: '周五',
      SATURDAY: '周六',
      SUNDAY: '周日',
      REBATE_PROPORTION: '返现比例只能是0-100的正整数',
      STATUS_NOTICE1: '上下架时间优先于上下架开关, 打开开关时确认上下架时间',
      STATUS_NOTICE2: '系统每小时会自动执行上下架操作',
      STOCK_CONFIRM: '库存修改确认',
      STOCK_TIP1: '您在编辑库存的时候实际库存可能已经发生变化',
      STOCK_TIP2: '是否确认修改库存为',
    },
    orders: {
      ORDERS_LIST: "订单列表",
      ORDERS_NUMBER: "订单号",
      ORDERS_EXP_DETAIL: "导出订单明细",
      ORDERS_PRICE: "订单原始金额",
      ORDERS_PAYMENT_PRICE: "已支付金额",
      ORDERS_NO_PRICE: "未支付金额",
      ORDERS_STATUS: "订单状态",
      ORDERS_PAID: "已付款",
      ORDERS_UNPAIED: "未付款",
      ORDERS_NOT_REFUND: "未退款",
      ORDERS_REFUND: "退款中",
      ORDERS_REFUND_FINISH: "退款完成",
      ORDERS_SYSTEM_REFUND: '系统退款',
      ORDERS_REFUND_REJECT: "退款拒绝",
      ORDERS_FINISH: "已完成",
      ORDERS_CREATED: "已下单",
      ORDERS_CANCEL: "已取消",
      ORDERS_PAID_HALF: "部分付款",
      ORDERS_PAST: "已过期",
      ORDERS_DETAIL: "订单信息",
      ACTIVITY_ORIGNAL_PRICE: "活动原价",
      ACTIVITY_DISCOUNT_PRICE: "活动特价",
      ORDERS_DISCOUNTS_PRICE: "订单优惠总额",
      ORDERS_REALITY_PRICE: "订单实际金额",
      ORDERS_UP_TIME: "下单时间",
      ORDERS_PAYMENT_TIME: "付款时间",
      ORDERS_ACTION: "订单操作",
      PAYMENT: "付款",
      REFUND: "退款",
      PAYMENT_HALF: "部分付款",
      REFUND_AGREE0: "同意退款",
      REFUND_REJECT: "拒绝退款",
      ORDERS_OFF: "订单关闭",
      ORDERS_VAIN: "无效",
      ORDERS_LOG: "订单日志",
      ORDERS_LOG_RECORD: "操作记录",
      OPERATOR: "操作员",
      TIME: "时间",
      DETERMINE_REFUND: "确定退款",
      ORDERS_STATISTICS: "订单统计",
      ORDERS_LOG_REMARKS: "请填写操作备注",
      ORDERS_GOD_PRICE: "请输入正确的价格",
      ORDERS_ACTUAL_PRICE: "付款金额不能超过订单实际金额",
      ORDERS_DETERMINE_REFUND: "确定退款吗？",
      ORDERS_GOD_DETERMINE_REFUND: "确定同意退款吗？",
      ORDERS_NOT_DETERMINE_REFUND: "确定拒绝退款吗？",
      ORDERS_NOT: "确定关闭吗",
      ORDERS_BASIC: "基本信息",
      DISCOUNTS_CHOICE: "优惠条件",
      DISCOUNTS_NOT: "此活动无优惠",
      PLEASE_ORDERS_PRICE: "请输入金额",
      ORDERS_DREFUND: "确定付款吗？",
      MAKE_CANCEL: "确定取消吗？",
      ORDERS_PRICE_INTEGER: "退款金额只能输入大于等于0的正整数",
      ORDERS_NOT_DETERMINE: "退款金额不能超过已付款金额",
      ORDERS_GIVE: "已赠送",
      ORDERS_GIVING: "转赠中",
      CONFIRM_TRANSFER: "确认接收",
      CANCEL_TRANSFER: "取消赠送",
      ORDERS_ACTUAL_NAME: "请输入店铺名称",
      ORDERS_SHOP_NAME: "请输入活动名称",
      ORDERS_GIVE_PEOP: "赠送人",
      ORDERS_GIVER: "接收人",
      ORDERS_QRCODE: "订单二维码",
      ORDERS_PRICE_TOTAL: "总金额",
      ORDERS_NUMBER_TOTAL: "订单数",
      ORDERS_PAYPRICE_TOTAL: "已付款金额",
      ORDERS_UP_START_TIME: "下单开始时间",
      ORDERS_UP_END_TIME: "下单结束时间",
      ORDERS_GIVE_START_TIME: "赠送开始时间",
      ORDERS_GIVE_END_TIME: "赠送结束时间",
      ORDERS_PAY_START_TIME: "付款开始时间",
      ORDERS_PAY_END_TIME: "付款结束时间",
      ORDERS_EXPORT_MANY: "导出订单不能超过1万条",
      ORDERS_GIVE_PERIOD: "赠送中",
      PAYMENT_LOG: "付款日志",
      PAYMENT_WAY: "支付方式",
      PAYMENT_PRICE: "支付金额",
      PAYMENT_TIME: "支付时间",
      SURE_GIVEN: "确定同意接收吗？",
      CANCEL_GIVEN: "确定取消接收吗？",
      VIP_PRICE: "付费会员价格",
      APPLE_PAY: "Apple Pay",
      IOS_PURCHASE: "Apple Pay IAP",
      ANDROID_PURCHASE: "Google Pay IAP",
      WEBMONEY_QUICK_APP: "WebMoney",
      POINTS_PAY: "Point",
      ALIPAY: "支付宝支付",
      WXPAY: "微信支付",
      PAYPAY: 'Paypay',
      PAYPAL: 'PayPal',
      GOOGLE_PAY: "Google Pay",
      JAPAN_PAY: "信用卡支付",
      OFFLINE_PAY: "线下支付",
      PLATFORM_PAY: "平台付款",
      UMS_PAY: "UMS付款",
      ORDER_PAYMENT: "订单已付款金额",
      FREE_ORDER: "免费订单",
      PAY_STATUS: "支付状态",
      REFUND_STATUS: "退款状态",
      VALID: "有效",
      INVALID: "无效",
      PAY_POINT: "已支付点数",
      REFUND_PRICE: "已退款金额",
      DELETE_TIME: "删除时间",
      REFUND_TIME: "退款时间",
      UPDATE_TIME: "最后操作更新时间",
      ACTION_FROM: "操作来源",
      DEVICE_ID: "设备ID",
      OTHER_TX_SN: "第三方交易流水号",
      OTHER_TX_ORDER_SN: "第三方交易订单号",
      PAYMNET_PLATEFORM: "支付平台",
      PAYMENT_TYPE: "支付类型",
      ACTION_WAY: "操作方式",
      PLEASE_WRITE_SN: "请输入订单号",
      SERIAL_NUM: "交易流水号",
      REFERRAL_INFOR: "推荐人信息",
      RECOMMED_CODE: "推荐码",
      PAY_DETAIL: "备注信息",
      PAY_FAIL: "支付失败",
      GOODS_SN: '商品号',
      GOODS_NUM_TOTAL: '商品数',
      USAGE_STATUS: '使用状态',
      PRODUCT_INFO: '商品信息',
      PRODUCT_NAME: '商品名称',
      USER_ID: '用户ID',
      USERGOODS_CREATE_START: '商品创建开始时间',
      USERGOODS_CREATE_END: '商品创建结束时间',
      USERGOODS_GIVEN_LOG: '商品赠送日志',
      USERGOODS_VALID_START: '有效期开始时间',
      USERGOODS_VALID_END: '有效期结束时间',
      USERGOODS_CREATE_TIME:'商品创建时间',
      GOODS_STATUS: '商品状态'
    },
    member: {
      DJ_USERS: '认证DJ用户',
      HOTONLINE_USERS: '认证网红用户',
      SOURCE_FRIEND_TRANSFER: '转赠',
      SOURCE_ORDER_REFUND: '订单退款',
      SOURCE_ADMIN_MODIFIED: '管理员修改',
      SOURCE_ORDER_REBATE: '购买返点',
      SOURCE_STORE_ONSITE: '线下店铺消费',
      SOURCE_ONLINE_TOPUP: '应用内充值',
      SOURCE_ORDER_PURCHASE: '活动购买',
      SOURCE_GIFT_PURCHASE: '礼物打赏',
      SOURCE_NEW_USER: '新用户注册',
      SOURCE_DAILY_LOGIN: '每日登录',
      SOURCE_LIVE_PURCHASE: '付费节目',
      SOURCE_REFERRAL_COIN: '推荐注册',
      SOURCE_VD_TOPUP: '储值机充值',
      SOURCE_GAME: '游戏',
      SOURCE_MERCHANT_TOPUP: '核销端充值',
      SOURCE_EXPIRED: '过期',
      VIP_PRIVILEGE: '付费会员特权',
      MEMBER_APPLY_INFO: '申请信息',
      REMAINING_BALANCE: '余额',
      IM_BLOCKED_OPEN: '解禁此会员',
      IM_BLOCKED_CLOSED: '禁言此会员',
      MEMBERS_AVAILABLE_POINT: '可用点数',
      POINT_VALID_DAY: '有效期',
      MEMBERS_LIST: "会员列表",
      MEMBERS_CREATE: "创建会员",
      MEMBERS_NICKNAME: "昵称",
      MEMBERS_NAME: "姓名",
      MEMBERS_SEX: "性别",
      MAN: "男",
      WOMAN: "女",
      SECRECY: "保密",
      MEMBERS_ENROLL: "注册时间",
      MEMBERS_POINT: "点数",
      MEMBERS_STATUS: "会员状态",
      ALREADY_AUDIT: "审核通过",
      ALREADY_NOT: "审核未通过",
      ALREADY_NONE: "未审核",
      MEMBERS_BLACKLIST: "黑名单",
      MEMBERS_BLACKLIST_LIST: "黑名单列表",
      BLACKLIST_HAVE: "有黑名单记录",
      BLACKLIST_NOT: "无黑名单记录",
      MEMBERS_IDENTITY: "身份证",
      MEMBERS_IDENTITY_DETAIL: "身份证信息",
      ALREADY_UPLOADING: "已上传",
      NOT_UPLOADING: "未上传",
      MEMBERS_DETAIL: "会员信息",
      MEMBERS_BIRTHDAY: "生日",
      MEMBERS_PROFESSION: "职业",
      MEMBERS_STATE: "国籍",
      ADDRESS_COUNTY: "地址 - 都/道/府/县",
      ADDRESS_CITY: "地址 - 市/郡",
      ADDRESS_STREET: "地址 - 街道",
      ADDRESS_ADDITIONAL: "地址 - 额外信息",
      ADDRESS_POSTCODE: "邮编",
      COMPLETENESS: "完成度",
      BADNESS_TIME: "不良记录时间",
      BLACKLIST_CREATE: "创建黑名单",
      COMMENT: "备注",
      ADD_BLACKLIST_HAVE: "增加用户黑名单记录",
      DOCUMENTING: "记录时间",
      MEMBERS_EXP: "会员导出",
      MEMBERS_LAST_TIME: "上次登录时间",
      VERIFICATION_IDENTITY: "验证身份证",
      PLEASE_MEMBERS_NICKNAME: "请输入昵称",
      PLEASE_MEMBERS_NAME: "请输入姓名",
      PLEASE_MEMBERS_JID: "请输入JID",
      PLEASE_MEMBERS_NICKNAME_LENGTH: "昵称不能超过30位",
      PLEASE_MEMBERS_NAME_LENGTH: "姓名不能超过30位",
      ADDRESS_COUNTY_LENGTH: "都/道/府/县超过最大输入限制",
      ADDRESS_CITY_LENGTH: "市/郡超过最大输入限制",
      ADDRESS_STREET_LENGTH: "街道超过最大输入限制",
      ADDRESS_ADDITIONAL_LENGTH: "额外信息超过最大输入限制",
      ADDRESS_POSTCODE_LENGTH: "邮编最大输入8位",
      MEMBERS_IDENTITY_ZF: "需要用户上传身份证正反面的照片",
      MEMBERS_SEX_OPEN: "性别是否公开",
      MEMBERS_TEL_OPEN: "手机号是否公开",
      PLEASE_ACTIVITY: "请选择活动",
      PLEASE_MEMBERS_DESC: "请填写描述",
      ADD_MEMBER: "新建会员等级",
      RECHARGE_PEOPLE: "付费人数",
      VALIDIY: "有效时间",
      MEMBERS_GRADE_NAME: "会员等级名称",
      MEMBERS_NUMBER: "请输入优惠券数量",
      YEAR: "年",
      MOUTH: "月",
      DAY: "日",
      MEMBERS_PRIVILEGE: "会员特权",
      ADD_MEMBERS_PRIVILEGE: "添加特权",
      MEMBERS_IDENTITY_NULL: "此用户没有上传身份证",
      ALL_SHOPS_APPLY: "全店铺适用",
      SHOP_PICTURES: "添加图片",
      JID_FORMAT: "J-ID只能输入数字或字母合且不能超过20位",
      BAGDE: "是否开启徽章",
      MEMBER_AVATER: "好友头像",
      MENBERSHIP: "优享会员(1个月)",
      RELATED_PURCHARSE: "关联内购商品",
      MENBER_OFFICE_SWITCH: "官方认证会员",
      USER_STATUS: "会员认证状态",
      WOMAN_SWITCH: "BEAUTY会员",
      SURE_MODIFY_POIONT: "确认修改点数？",
      SURE_MODIFY_COIN: "确认修改金币数？",
      POINT_RECORD: "点数记录",
      COIN_RECORD: "金币记录",
      POINT_INFOR: "说明",
      BLACKLIST_RECORD: "黑名单记录",
      FRIENDS_LIST: "好友列表",
      UPLOAD_AVATAR: "上传头像",
      TEST_POINT: "点数只能是大于等于0的整数",
      TEST_COIN: "金币数只能是大于等于0的整数",
      MAX_VALID: "有效时间只能是大于0的整数",
      PLEASE_PIONT: "请输入点数",
      PLEASE_COIN: "请输入金币数",
      UAER_EMAIL: "邮箱",
      UAER_INFORMATION: "用户信息",
      SCREEN_ITEMS: '筛选项',
      VIP_TYPE: '付费会员类型',
      E_MAIL: '邮箱',
      JID: 'JID',
      USER_ID: '用户ID',
      RECOMMEND_STATUS: '推荐状态',
      HAS_RECOMMENDER: '有推荐人',
      NO_RECOMMENDER: '无推荐人',
    },
    coupon: {
      PRICE_COUPON_PA: '价格',
      COUPON_NUMBER: "优惠券数量",
      COUPON_TYPE: "优惠券名称",
      ROLES_USERS: "所属用户",
      GIVE_AT: "赠送时间",
      USED_AT: "使用时间",
      END_AT: "到期时间",
      VERIFICATION_NAME: "核销店铺",
      ALL: "全部",
      NOT_USED: "未使用",
      ALREADY_USED: "已使用",
      OVERDUED: "已过期",
      LOGO_PESOLVING: "建议分辨率为 300*300 以下",
      SHOPS_NON_EXISTENT: "该店铺不存在",
      COUPON_SEND_NUMBER: "发出数量",
      COUPON_LIST: "优惠劵列表",
      COUPON_CREATE: "创建优惠劵",
      COUPON_NAME: "优惠劵名称",
      COUPON_TIME: "有效时间",
      COUPON_AMOUNT: "已发出数量",
      COUPON_LOGO: "优惠劵Logo",
      COUPON_NUM: "优惠劵数量",
      ORDER_AMOUNT: "订单金额",
      COUPON_AMOUNT_AMONG: "价格区间",
      COUPON_AMOUNT_MAX: "最大金额",
      COUPON_AMOUNT_MIN: "最小金额",
      CORRECT_COUPON_NUM: "请输入正确的优惠劵数量",
      COUPON_AMOUNT_MAX_NULL: "请输入最大金额",
      COUPON_AMOUNT_MIN_NULL: "请输入最小金额",
      COUPON_NULL: "请选择优惠券",
      EDIT_COUNT: "编辑数量",
      COUPON_NAME_LENGTH_MAX: "优惠劵名称过长",
      COUPON_NAME_NULL: "优惠券名称不能为空",
      COUPON_TIME_YEAR: "有效时间不能大于10年",
      COUPON_TIME_MONTH: "有效时间不能大于30月",
      COUPON_TIME_DAY: "有效时间不能大于365天",
      COUPON_TIME_INT: "有效时间只能输入大于等于0的正整数",
      PLEASE_SELECT_COUPONS: "请选择要添加的优惠券",
      COUPONS_COUNT: "已选优惠券未填写发出数量",
      PLEASE_COUNT: "请输入数量",
      PLEASE_DELETE_COUPONS: "请选择要删除的优惠券",
      USE_START_AT: "使用开始时间",
      USE_END_AT: "使用结束时间",
      CUPONS_CONTENT: "优惠券说明",
      MERGE_SETTING: "多语言合并设置",
      SEND_SHOPS: "可领取的店铺"
    },
    articles: {
      ARTICES_LIST: "文本列表",
      ADD_ARTICES: "增加文本",
      ARTICES_NAME: "文本名称",
      ARTICES_MESSAGE: "文本信息",
      ARTICES_TYPE: "文本类型",
      ARTICES_LANGUAGE: "文本语言",
      ABOUT_US: "关于我们",
      USER_PROTOCOL: "用户协议",
      PROCLAMATION: "公告",
      ARTICES_HELP: "使用帮助",
      GAME_RULE: "游戏规则",
      LOGINOUT_EXPLAIN: "用户注销协议",
      VIP_EXPLAIN: "优享会员用户协议",
      ARTICES_CENTENT: "文本内容",
      PLEASE_ARTICES_NAME: "请输入文本名称",
      PLEASE_ARTICES_TYPE: "请选择文本类型",
      PLEASE_ARTICES_CENTENT: "请填写内容",
      PLEASE_ARTICES_LANGUAGE: "请填写文本语言",
      GIFT_NOTICE: "直播打赏说明",
      ID_PROTOCOL: "身份证法律协议"
    },
    appconfig: {
      APPCONFIG: "应用配置",
      APPCONFIG_PAY: "支付配置",
      APPCONFIG_SHARE: "分享设置",
      APPCONFIG_SPOT: "点数比例设置",
      APPCONFIG_COIN: "金币兑换比例",
      APPCONFIG_EXCHANGE: "汇率设置",
      APPCONFIG_EXCHANGE_TEXT: "日元兑人民币汇率",
      APPCONFIG_PAY_ALIPAY: "支付宝开放平台",
      APPCONFIG_PAY_WECHAT: "微信开放平台",
      APPCONFIG_PAY_LOCAL: "信用卡支付",
      APPCONFIG_SPOT_TXT: "一日元所赠送的点数",
      APPCONFIG_COIN_TXT: "一金币所赠送的日元",
      APPCONFIG_SPOT_ONE: "点数比例必须为大于等于1的整数",
      APPCONFIG_SPOT_ZS: "点数比例只能是整数",
      APPCONFIG_SPOT_DS: "金币所兑换的日元必须是大于等于1的整数",
      APPCONFIG_SPOT_YS: "金币所兑换的日元必须是整数",
      APPCONFIG_LUCK: "老虎机金币抽奖设置",
      APPCONFIG_IM: "IM設定",
      APPCONFIG_IM_UPG: "上传IM公钥",
      APPCONFIG_IM_UPS: "上传IM私钥",
      APPCONFIG_DSF: "第三方社交平台链接",
      VERSIONS_SET: "版本设置",
      VERSIONS_NUMBER: "强制更新版本号",
      VERSIONS_EXAMINE: "审核更新版本号",
      NEW_USER_FREE_VIP: "新用户赠送优享会员",
      IS_NEW_USER_FREE_VIP: "是否开启新用户赠送优享会员",
      FEMALE_VALID_DAY: "BEAUTY会员有效期（天）",
      PLEASE_FEMALE_VALID_DAY: "BEAUTY会员有效期只能输入大于0的正整数",
      DAY_LOGIN_COIN: "每日登陆赠送金币",
      NEW_USER_REGISTER_COIN: "新用户注册赠送金币",
      IS_OPEN_DAY_LOGIN: "是否开启每日登录赠送金币",
      IS_OPEN_NEW_USER: "是否开启新用户注册赠送金币",
      DAY_LOGIN_COIN_NUM: "每日登陆赠送金币数",
      NEW_USER_REGISTER_COIN_NUM: "新用户注册赠送金币数",
      PLEASE_DAY_LOGIN_COIN_NUM: "每日登陆赠送金币数只能输入大于0的正整数",
      PLEASE_NEW_USER_REGISTER_COIN_NUM:
        "新用户注册赠送金币数只能输入大于0的正整数",
      RECOMMED_REGISTER_COIN: "推荐注册送金币",
      IS_OPEN_RECOMMED_REGISTER_COIN: "是否开启推荐注册送金币",
      RECOMMED_REGISTER_COIN_NUM: "推荐注册送金币数",
      PLEASE_RECOMMED_REGISTER_COIN_NUM:
        "推荐注册送金币数只能输入大于0的正整数",
      OPREATE_SET: "运营设置",
      PLEASE_WITER_RATE: "请输入汇率",
      PLEASE_COIN_PRIZE: "请输入老虎机中奖金币数",
      SYSTEM_SET: "系统设置",
      GOOGLE_KEY: "请输入Google Key",
      CACHE_OPEN: "缓存管理",
      REGION_CACHE: "区域缓存",
      GET_REGION_CACHE: "获取区域缓存",
      OPEN_SHOP_REGION: "开通店铺区域缓存",
      GET_OPEN_SHOP_REGION: "获取开通店铺区域缓存",
      TEL_REGION: "电话区号缓存",
      GET_TEL_REGION: "获取电话区号缓存",
      IM_MENBER_REGION: "IM会员信息",
      GET_IM_MENBER_REGION: "导入IM会员信息",
      PARTNER_ID: "合作身份者ID,以 2088 开头由 16 位纯数字组成的字符串",
      SELLER_ID: "支付宝收款账号,手机号码或邮箱格式",
      PUBLIC_KEY: "支付宝公钥",
      PRIVATE_KEY: "商户私钥",
      WECHAT_ID: "App ID",
      WECHAT_KEY: "App Secret",
      WECHAT_PRIVATE_NUMBER: "Merchant ID",
      WECHAT_PRIVATE_KEY: "Merchant Private Key",
      IM_UPG: "IM Public Key",
      IM_UPS: "IM Private Key"
    },
    invitatecodes: {
      CREATE_INVITATECODE: "创建邀请码",
      INVITATE_TYPE: "邀请码类型",
      PLEASE_CODE: "请输入邀请码",
      WOMAN_MEMBER: "BEAUTY会员"
    },
    dialog: {
      VALID_START_AT: "有效开始时间",
      VALID_END_AT: "有效结束时间",
      TIP_PICTURE: "弹窗图片",
      TIP_CONDITION: "弹窗条件",
      TIP_SWITCH: "弹窗开关",
      IS_OPEN_TIPS: "是否开启弹窗",
      PLEASE_TIPS_TYPE: "请选择弹窗条件"
    },
    theme: {
      THEME_ZIP: "主题名称",
      THEME_OPEN: "主题开关",
      DOWMLOAD_LINK: "下载链接",
      PLATFORM: "适用平台",
      ALL: "全部",
      IS_OPEN_THEME: "是否开启主题开关",
      PLEASE_THEME_ZIP: "请输入主题名称",
      PLEASE_PLATFORM: "请选择适用平台",
      THEME_FILE: "主题文件",
      PLEASE_THEME_FILE: "请上传主题文件"
    },
    roles: {
      ROLES_LIST: "角色列表",
      ROLES_CREATE: "创建角色",
      ROLES_GOD_CREATE: "创建角色成功",
      DEIT_ROLES: "编辑角色信息",
      ROLES_NAME: "名称",
      ROLES_SHOP: "所属店铺",
      FOUND_TIME: "创建日期",
      FOUND_RENEWAL: "更新日期",
      FOUND_DETAIL: "角色信息",
      ROLES_SCOPE: "所属范围",
      ROLES_HINT: "创建或编辑帐号属危险操作，请谨慎操作",
      PLEASE_ROLES_NAME: "请输入角色名称",
      PLEASE_ROLES_SCOPE: "请选择所属范围",
      PLEASE_ROLES_SHOP: "请选择所属店铺",
      PLEASE_ROLES_SCOPE_PT: "所属范围为平台不可选择",
      PLEASE_PREMISSION: "请选择角色权限",
      ROLE_PREMISSION: "角色权限",
      ROLE_UPDATE: "编辑权限",
      ROLE_READ: "查看权限",
      ROLE_CREATE: "创建权限",
      ROLE_DELETE: "删除权限",
      CHECK_ALL: "全选"
    },
    shoproles: {
      DEIT_ACCOUNTS: "编辑账号信息",
      SHOPROLE_CREATE: "创建店铺管理员",
      SHOPROLE_NOT_CREATE: "账号不能有特殊符号",
      PLASTROLE_CREATE: "创建平台管理员",
      SHOPROLE_LIST: "店铺管理员列表",
      PLATROLE_LIST: "平台管理员列表",
      SHOPROLE_NUMBER: "管理员账号",
      SHOPROLE_TEL: "管理员电话",
      SHOPROLE_RECENT_TIME: "最近登录时间",
      SHOPROLE_RECENT_IP: "最近登录IP",
      SHOPROLE_ROLES: "所属角色 ",
      PLEASE_SHOPROLE_NUMBER: "请输入正确的帐号，长度限制4到255个字符",
      PLEASE_SHOPROLE_SHOP: "请选择所属店铺",
      PLEASE_SHOPROLE_ROLES: "请选择角色",
      PLEASE_NAME: "请输入管理员账号",
      MANAGEMENT: "管理员"
    },
    ticket: {
      TICKET_NUM: "门票号",
      TICKET_NAME: "门票名称",
      TICKET_TIME: "门票时间",
      TICKET_STATUS: "门票状态",
      CREATE_TIME: "系统自动记录时间",
      ENTER_TIME: "入场时间",
      GIVEN_TIME: "转增时间",
      TICKET_INFOR: "门票信息",
      PAID_TICKET_COUNT: '已付款门票数量',
      UNPAID_TICKET_COUNT: '未付款门票数量',
      TICKET_GIVEN_LOG: "门票赠送日志",
      TICKET_PRICE: "门票价格",
      TICKET_START_STATUS: "门票开始状态",
      TICKET_END_STATUS: "门票结束状态",
      TICKET_ID: "门票ID",
      SESSION_NAME: "场次名称",
      SEVERCE_CALLBACK: "服务器回调",
      PAY_STATUS: "支付状态",
      EXPORT_TICKET: "导出门票明细",
      TICKET_EXPORT_MANY: "导出门票不能超过1万条",
      TICKET_AMOUNT: "门票数",
      TICKET_STATUS_PAY: "已付款",
      TICKET_STATUS_USED: "已使用",
      TICKET_STATUS_INVALID: "已失效",
      TICKET_CREATE_START: "门票创建开始时间",
      TICKET_CREATE_END: "门票创建结束时间",
      TICKET_MERCHANT: "商家",
      TICKET_AETTIME: "定时器",
      TIME_DELETE_TIPS: '删除门票记录时间会导致门票使用状态变化，请谨慎操作！',
      ALREADY_DELETED: '已删除',
      TICKET_INDEX_LABEL: '整理券ID',
      TICKET_CREATE_TIME:'门票创建时间',
    },
    live: {
      LIVE_LIST: "直播列表",
      LIVE_CREATE: "创建直播",
      LIVE_ONE_PHOTO: "直播首图",
      LIVE_NAME: "直播名称",
      LIVE_TIME: "直播时间",
      LIVE_URL: "直播URL",
      LIVE_VIRTUAL: "点赞数",
      LIVE_SPUTAWAY: "是否有效",
      LIVE_STATUS: "状态",
      LIVE_DETAIL: "直播信息",
      LIVE_DESC: "直播描述",
      LIVE_PHOTO: "直播海报图片",
      LIVE_LINK: "直播链接",
      PLEASE_LIVE_LINK: "请输入直播链接",
      LIVE_NO_OPEN: "未开始",
      LIVE_YJ_OPEN: "进行中",
      LIVE_RECOMMEND: "是否推荐",
      LIVE_PUTAWAY: "正在上架",
      LIVE_X_DETAIL: "直播详情",
      LIVE_SITE: "直播地址",
      LIVE_DESC_NAME: "请输入直播名称与描述",
      PLEASE_LIVE_NAME: "请输入直播名称",
      PLEASE_LIVE_DESC: "请输入直播描述",
      PLEASE_LIVE_NAME_LENGTH: "直播名称超过最大范围",
      PLEASE_LIVE_DESC_LENGTH: "直播地址超过最大输入长度",
      LIVE_DZS: "虚拟点赞数",
      PLEASE_LIVE_COPY: "确定要复制此直播吗？",
      LIVE_TYPE: "直播类型",
      LIVE_PLAT: "平台直播",
      LIVE_SHOP: "店铺直播",
      PUBLISH_START_AT: "上架时间",
      PUBLISH_END_AT: "下架时间",
      PUBLISH_TIME: "上下架时间",
      PUBLISH_START_AT_NULL: "请选择上架时间",
      PUBLISH_END_AT_NULL: "请选择下架时间",
      STREAM_NAME: "推流名称",
      STREAM_NAME_NULL: "请输入推流名称",
      STREAM_LINK: "推流链接",
      LIVE_VIP: "优享会员专属直播",
      VIRTURE: "虚拟在线人数",
      LIVE_LEFT_UP_COIN: "直播左上图标",
      LIVE_RIGHT_COIN: "直播右上图标",
      LIVE_LEFT_DOWN_COIN: "直播左下图标",
      LIVE_TIPS_ONE: "直播文字说明1",
      LIVE_TIPS_TWO: "直播文字说明2",
      LIVE_NOTICE: "直播公告",
      LIVE_NOTICE_MORE: "直播公告不能超过150个字",
      LIVE_RESET: "重置聊天室成员",
      LIVE_CATEGORY_NUM: "分类下直播数",
      LIVE_CLASSCIFY: "直播所属分类",
      LIVE_RESORCE: "直播源",
      STREAM: "推流",
      LIVE_COIN: "直播消耗金币数",
      ONLINE_NUM: "在线人数"
    },
    gift: {
      GIFT_NAME: "礼物名称",
      GIFT_ICON: "礼物图标",
      GIFT_AMOUNT: "礼物金币",
      GIFT_ZIP: "礼物动画",
      GIFT_CREATE: "创建礼物",
      GIFT_DEIT: "编辑礼物",
      GIFT_NAME_LENGTH_MAX: "礼物名称过长",
      GIFT_NAME_NULL: "请输入礼物名称",
      GIFT_AMOUNT_NULL: "请输入礼物点数",
      GIFT_ICON_NULL: "请上传礼物图标",
      GIFT_ZIP_NULL: "请上传礼物动画",
      GIFT_AMOUNT_INTEGER: "礼物金币只能输入整数",
      GIFT_BAGE: "礼物优惠券",
      GIFT_PUTAWAY: "上下架",
      COIN: "金币数",
      REWARD_TIME: "打赏时间",
      EXPORT_GIFT_REWARD: "导出礼物打赏记录",
      GIFT_CATEGORY_NAME: "礼物分类名称",
      GIFT_CATEGORY_IMAGE: "礼物分类图片",
      GIFT_CATEGORY_NUM: "分类下礼物数",
      GIFT_CLASSCIFY: "礼物所属分类",
      PRESET_CREATE: "创建礼品",
      PRESENT_EDIT: "编辑礼品"
    },
    comments: {
      COMMENTS_LIST: "评论列表",
      COMMENTS_CENTENT: "评论内容",
      COMMENTS_TIME: " 评论时间"
    },
    actionslog: {
      ACTIONS_LOG_LIST: "日志列表",
      ACTIONS_LOG_ADMIN: "账号",
      ACTIONS_LOG_CONTENT: "内容",
      ACTIONS_LOG_TIME: "日期"
    },
    languages: {
      LANGUAGES_LIST: "多语言列表",
      LANGUAGES_CREATE: "增加语言",
      LANGUAGE_EDIT: "编辑语言",
      LANGUAGES_NAME: "语言名称",
      LANGUAGES_SIGN: "语言标记  ",
      LANGUAGES_DETAIL: "多语言信息",
      PLEASE_LANGUAGES_NAME: "请输入名称",
      PLEASE_LANGUAGES_SIGN: "请输入标记"
    },
    recharges: {
      RECHARGR_NUMBER: "充值订单号",
      RECHARGE_SN: "充值交易流水号",
      RECHARGE_PRICE: "充值金额",
      RECHARGE_COIN: "充值获得金币",
      RECHARGE_POINT: "充值获得点数",
      RECHARGE_TIME: "充值时间",
      RECHARGES_LIST: "充值列表",
      RECHARGES_PRICE: "金额",
      EXCHANGE_COIN: "充值金币数",
      EXCHANGE_POINT: "赠送点数",
      BUY_IN_GOODS: "内购商品ID",
      RECHARGE_IS_VALID: "充值是否有效",
      CREATE_RECHARGE: "创建充值项",
      EDIT_RECHARGE: "编辑充值项",
      PLEASE_RECHARGE_PRECE: "请输入充值金额",
      PLEASE_RECHARGE_COIN: "请输入充值金币数",
      PLEASE_RECHARGE_POINT: "请输入赠送点数",
      PLEASE_IPAID: "请输入内购商品ID",
      PLEASE_VALID: "请选择是否有效",
      RECHARGE_AMOUNT_INTPRICE: "金额只能输入整数",
      RECHARGE_AMOUNT_INTCOIN: "充值金币数只能输入整数",
      RECHARGE_AMOUNT_INTPOINT: "赠送点数只能输入整数",
      EXPORT_COIN_RECHARGE: "导出金币充值记录",
      COIN_EXPORT_MANY: "金币导出不能超过1万条"
    },
    musics: {
      MUSIOCS_LIST: "音乐类型列表",
      MUSIOCS_TYPE: "音乐类型",
      MUSIOCS_LOGO: "音乐Logo",
      MUSIOCS_ACTIVITY: "活动数",
      MUSIOCS_DATEIL: "音乐类型信息",
      PLEASE_MUSIOCS_TYPR: "音乐类型不能为空",
      PLEASE_LOGO: "请上传音乐Logo",
      PLEASE_MUSIOCS_TYPR_LENGTH: "字数超过最大限制",
      CREATE_MUSIC: "创建音乐",
      EDIT_MUSIC: "编辑音乐"
    },
    membership: {
      MEMBERSHIP_LEVEL_NAME: "会员等级名称",
      CREATE_MEMBERSHIP: "创建优享会员",
      PLEASE_MEMBERS_GRADE_NAME: "请选择会员等级",
      NONE_VIP_MEMBERSHIP: "免费会员"
    },
    banner: {
      BANER_LIST: "广告列表",
      BANER_TITLE: "标题",
      BANER_DATEIL: "广告信息",
      BANER_FOUND_ONE: "创建Banner广告",
      BANER_FOUND_TWO: "创建店铺广告",
      REGIONS_BANER_TITLE: "标题不能为空",
      BANER_PHOTO: "请上传图片",
      BANER_SORT: "排序只能为正整数",
      BANER_HINT: "图片长宽不能大于960*540",
      BANER_HINT_TWO: "图片大小不能大于1M",
      CLICKS_NUMBER: "点击数",
      CLICKS_EMPTY: "清空",
      BANNER_NOTICE_ONE:
        "广告横幅1用的图像尺寸大于960×540，必须维持16:9的比例。",
      BANNER_NOTICE_TWO:
        "广告横幅2用的图像尺寸大于960×540，必须维持16:9的比例。",
      SURE_CLEAR: "确认清空吗？"
    },
    splashes: {
      SPLASHES: "闪屏",
      SPLASHES_LIST: "闪屏列表",
      SPLASHES_CREATE: "创建闪屏",
      SPLASHES_TIME_SC: "时长",
      SPLASHES_TOP_TIME: "上架时间",
      SPLASHES_UP_TIME: "下架时间",
      SPLASHES_SHOW_TIME: "展示时间",
      ANDRIOD_PHOTO: "Andriod图片",
      IOS_PHOTO: "iOS图片",
      SPLASHES_TOP_TIME_xj: "上架时间从新到旧",
      SPLASHES_TOP_TIME_jx: "上架时间从旧到新",
      SPLASHES_UP_TIME_xj: "下架时间从新到旧",
      SPLASHES_UP_TIME_jx: "下架时间从旧到新",
      SPLASHES_HINT: "请确保图片比例正确",
      SPLASHES_HINT_TWO: "请确保展示时间正确",
      PLEASE_ANDRIOD_PHOTO: "请选择Android图片",
      PLEASE_IOS_PHOTO: "请选择iOS图片",
      PLEASE_SHOW_TIME: "展示时间只能为整数",
      PLEASE_SPLASHES_SHOW_TIME: "请输入展示时间",
      PLEASE_SPLASHES_LINK: "请输入正确的网址",
      SPLASHES_DETAIL: "闪屏信息",
      SPLASHES_PHOTO_BL: "请确保图片比例正确",
      SPLASHES_PHOTO_TIME: "请确保展示时间正确",
      DELETE_SPLASHES: "请选择要删除的闪屏"
    },
    versions: {
      VERSIONS_LIST: "版本列表",
      CREATE_VERSIONS: "创建版本",
      VERSIONS_NUMVER: "版本号",
      VERSIONS_CENTEN: "更新内容",
      VERSIONS_URL: "下载地址",
      VERSIONS_DETAIL: "版本信息",
      VERSIONS_WB_URL: "外部链接",
      VERSIONS_DESC: "描述",
      SPLASHES_VERSIONS_DESC: "请输入描述",
      VERSIONS_DESC_ONE: "请确保版本号格式正确",
      VERSIONS_DESC_TWO: "请确保下载地址正确",
      VERSIONS_DESC_THREE: "创建后默认状态为禁用，请手动开启",
      VERSION_CREATE_NEW: "创建时间从新到旧",
      VERSION_CREATE_OLD: "创建时间从旧到新",
      DELETE_VERSIONS: "请选择要删除的版本",
      PLEASE_CLOSE_AN: "请关闭已经启用的Android版本",
      PLEASE_CLOSE_IOS: "请关闭已经启用的iOS版本",
      EDIT_VERSION: "编辑版本"
    },
    pushes: {
      PUSHES: "推送",
      PUSHES_LIST: "推送列表",
      PUSHES_CREATE: "创建推送",
      PUSHES_TIME: "推送时间",
      PUSHES_DETAIL: "推送信息",
      PUSHES_TIMING: "定时",
      PUSHES_CREATE_TIME: "创建时间",
      PUSHES_SELECT_TYPE: "选择类型",
      PUSHES_IMMED_TYPE: "立即发送",
      PUSHES_TIMING_TYPE: "定时发送",
      ALL_PLATFORM: "全平台",
      Yj_PLATFORM: "已发送",
      WL_PLATFORM: "未发送",
      PUSHES_TITLE: "标题超过最大限制",
      PUSHES_TYPE: "请选择发送类型",
      LINK_SHOP: "附近店铺",
      LINK_REC_SHOP: "推荐店铺",
      LINK_ACTIVITY: "今日活动",
      LINK_CUSTOM: "自定义",
      LINK_PUSHES_TITLE: "请输入标题",
      PUSH_TIME_NEW_OLD: "推送时间从新到旧",
      PUSH_TIME_OLD_NEW: "推送时间从旧到新",
      PUSH_AGAIN: "再次发送",
      PERSON_INFORMATION: "个人中心",
      MY_POINT: "我的点数",
      MY_ORDER: "我的订单",
      REGISTER_PAGE: "注册页面",
      FRIENDS_APPLY: "好友申请",
      MY_INVITE: "我的邀请",
      FEEDBACK: "意见反馈",
      MY_COUPONS: "我的优惠券"
    },
    prize: {
      PRIZE_SET: "中奖设置",
      PRIZE_LIST: "中奖列表",
      PRIZE_NAME: "中奖名称",
      PRIZE_CREATE: "创建中奖条件",
      PRIZE_PHOTO: "中奖图片",
      PRIZE_PROBABILITY: "中奖机率",
      PRIZE_PPINT: "赠送的点数",
      PRIZE_EDIT: "编辑中奖条件信息",
      PRIZE_DETAIL: "中奖信息",
      PRIZE_NAME_LENGTH: "中奖名称超长",
      PLEASE_PRIZE_NAME: "请输入中奖名称",
      PLEASE_PRIZE_PHOTO: "请上传中奖图片",
      PLEASE_PRIZE_PROBABILITY: "请输入中奖几率",
      PRIZE_PROBABILITY_RANGE: "中奖几率只能在0和1之间",
      PRIZE_PROBABILITY_NUMBER: "中奖几率只能输入数字",
      PRIZE_PROBABILITY_DECI: "中奖几率最多可输入4位小数",
      PRIZE_PPINT_NUMBER: "赠送点数只能是整数",
      PLEASE_PRIZE_PPINT: "请输入赠送点数",
      PLEASE_PRIZE_PESULT: "结果",
      PRIZE_TIME: "游戏时间",
      PRIZE_DETAILS: "游戏消费明细",
      PRIZE_DETAILS_LIST: "消费明细列表",
      PRIZE_DETAILS_GOLD: "消耗金币数",
      PRIZE_PESOLVING: "建议分辨率为 320*320 以下",
      USER_JID: "用户J_ID",
      PRIZE: "中奖",
      UNPRIZE: "未中奖"
    },
    regions: {
      SHOPS_NUM: "店铺数",
      CREATE_REGIONS: "新增区域",
      REGIONS_NAME: "区域名称",
      PLEASE_REGIONS_NAME: "请输入区域名称",
      REGIONS_DETAIL: "区域信息",
      ADD_SUBREGION: "新增下级区域",
      REGION: '区域',
    },
    points: {
      INCREASE_POINTS: '增加点数',
      CONSUMPTION_POINTS: '消费点数',
      CONSUMER_STORES: '消费店铺',
      CONSUMER_ACTIVITIES: '消费活动',
      SOURCE: '交易来源',
      COUPON_PURCHASE: '优惠卷购买',
      STORE_SIGNIN: '店铺签到',
      EVOWECHATPAY: 'EVO微信支付',
      CREDITCARD: '日本本地信用卡支付',
      INCREASE_TOTAL: '增加总点数',
      REDUCE_TOTAL: '消费总点数',
      EXPORT_SIGNIN_RECORD: '导出记录',
      DOWN_LOAD: '下载',
      EXPORT_LOADING: '下载中……请查看下载列表',
      POINT_VALID_DAY: '有效期',
      POINT_EXPORT_MANY: '导出点数记录不能超过1万条',
      SUBSCRIPTION_GIFT: '订阅赠送'
    }
  },
  router: {
    common: {
      CREATE: '创建',
      EDIT: '编辑',
      ACTIVITY_SESSION: '活动场次',
      ACTIVITY_TICKET: '活动门票',
      INDEX: '首页',
      ORDER: '门票订单管理',
      ORDER_SAT: '订单统计',
      QR_CODE: '二维码管理',
      TICKET: '用户门票管理',
      USERGOODS_MANAGEMENT: '用户商品管理'
    }
  }
};
